import { isBrowser } from './environment';

export function parseQueryParams(url: string): Record<string, string> {
  try {
    return Object.fromEntries(new URL(url).searchParams);
  } catch {
    return {};
  }
}

/**
 * Base for resolving relative hrefs with `new URL`. The server has no `window`, so it
 * falls back to the canonical site origin; callers keep relative inputs relative.
 */
export function getUrlParseBase(): string {
  return isBrowser() ? window.location.origin : 'https://www.chime.com';
}

/**
 * Returns the hostname plus each parent domain up to (but not including) the
 * single-label TLD. e.g. `chime-com-dev1.chime.com` → `['chime-com-dev1.chime.com', 'chime.com']`.
 * Empty/single-label inputs (`'localhost'`, `''`) return `[]`.
 */
export function getHostSuffixes(hostname: string): string[] {
  const parts = hostname.split('.');
  const suffixes: string[] = [];
  for (let i = 0; i < parts.length - 1; i++) {
    suffixes.push(parts.slice(i).join('.'));
  }
  return suffixes;
}
